export default "__VITE_ASSET__3GTfozm___"